var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"news"},[_vm._v(" 意见反馈 "),_c('AiPop',{on:{"change":_vm.showDialog}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }